import React from "react";
import { observer } from "mobx-react";
import { SignedEditionSadaicWorkflowStateViewStore } from "../../store";
import { SignedEditionSadaicWorkflowStateViewForm } from "./SignedEditionSadaicWorkflowStateViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type SignedEditionSadaicWorkflowStateViewProps = {
  signedEditionSadaicWorkflowStateViewStore: SignedEditionSadaicWorkflowStateViewStore;
};

export const SignedEditionSadaicWorkflowStateView: React.FC<SignedEditionSadaicWorkflowStateViewProps> =
  observer(({ signedEditionSadaicWorkflowStateViewStore }) => {
    return (
      <div>
        <SignedEditionSadaicWorkflowStateViewForm
          name_es={signedEditionSadaicWorkflowStateViewStore.name_esValue}
          name_en={signedEditionSadaicWorkflowStateViewStore.name_enValue}
          name_pt={signedEditionSadaicWorkflowStateViewStore.name_ptValue}
          onPrint={(handlePrint: () => void) =>
            signedEditionSadaicWorkflowStateViewStore.printSignedEditionSadaicWorkflowState(
              handlePrint
            )
          }
          onCancel={() =>
            signedEditionSadaicWorkflowStateViewStore.cancelSignedEditionSadaicWorkflowState()
          }
          onEdit={
            signedEditionSadaicWorkflowStateViewStore.isEditEnabled
              ? () =>
                  signedEditionSadaicWorkflowStateViewStore.editSignedEditionSadaicWorkflowState()
              : undefined
          }
        />
        <ErrorDialog
          open={signedEditionSadaicWorkflowStateViewStore.errorDialogOpened}
          title={signedEditionSadaicWorkflowStateViewStore.errorTitle}
          description={
            signedEditionSadaicWorkflowStateViewStore.errorDescription
          }
          onClose={() =>
            signedEditionSadaicWorkflowStateViewStore.closeErrorDialog()
          }
        />
      </div>
    );
  });
